export const enum PersonalizedEngineEndpointKeys {
  GET_PERSONALIZED_CONTENT_URL = 'GET_PERSONALIZED_CONTENT_URL'
}
